import { createSlice } from '@reduxjs/toolkit';
import { createSelectOptions } from '../../../../utils';
import {
	setSelectedMake,
	setSelectedModel,
	setSelectedYear,
} from './vehicleFiltersSlice';

const initialState = {
	productType: {
		selected: null,
		options: [],
	},
	productName: {
		selected: null,
		colorOptionsByName: {},
		options: [],
	},
	color: {
		selected: null,
		options: [],
	},
};

const productFiltersSlice = createSlice({
	name: 'newOrder/productsSearch/productFilters',
	initialState,
	reducers: {
		loadProductTypes(state, { payload: productTypes }) {
			return {
				...initialState,
				productType: {
					selected: null,
					options: productTypes.map((type) => ({
						value: type.id,
						content: type.name,
					})),
				},
			};
		},
		setSelectedProductType(state, { payload: selectedProductType }) {
			return {
				...state,
				productType: {
					...state.productType,
					selected: selectedProductType,
				},
				productName: {
					...initialState.productName,
				},
				color: {
					...initialState.color,
				},
			};
		},
		setProductNamesWithColor(state, { payload: productNamesWithColor }) {
			return {
				...state,
				productName: {
					...state.productName,
					options: createSelectOptions(
						Object.keys(productNamesWithColor).sort((a, b) =>
							a.localeCompare(b),
						),
						false,
					),
					colorOptionsByName: productNamesWithColor,
				},
			};
		},
		setSelectedProductName(state, { payload: selectedProductName }) {
			return {
				...state,
				productName: {
					...state.productName,
					selected: selectedProductName,
				},
				color: {
					selected: null,
					options: createSelectOptions(
						[
							...state.productName.colorOptionsByName[
								selectedProductName
							],
						]
							.map((colorOption) => colorOption.label)
							.sort((a, b) => a.localeCompare(b)) || [],
						false,
					),
				},
			};
		},
		setSelectedColor(state, { payload: selectedColor }) {
			return {
				...state,
				color: {
					...state.color,
					selected: selectedColor,
				},
			};
		},
	},
	extraReducers: (builder) => {
		function resetProductFilters(state) {
			return {
				...state,
				productType: {
					...state.productType,
					selected: null,
				},
				productName: {
					...initialState.productName,
				},
				color: {
					...initialState.color,
				},
			};
		}

		builder.addCase(setSelectedYear, resetProductFilters);
		builder.addCase(setSelectedMake, resetProductFilters);
		builder.addCase(setSelectedModel, resetProductFilters);
	},
});

export { initialState };
export const {
	loadProductTypes,
	setSelectedProductType,
	setProductNamesWithColor,
	setSelectedProductName,
	setSelectedColor,
} = productFiltersSlice.actions;

export default productFiltersSlice.reducer;
